import { useEffect } from 'react';
import { Link } from 'react-router';
import { platform } from '../lib/api';
import { setAppTitle } from '../lib/format';
import { SaleStatusChip, useLoad } from './common';

export function SalesPage() {
  const { data, error } = useLoad(() => platform.sales());
  useEffect(() => setAppTitle('Sales'), []);

  return (
    <main className="page wide pa-page">
      <header className="pa-head">
        <h1>Sales</h1>
        <Link className="btn primary" to="/platform-admin/sales/new">New sale</Link>
      </header>
      {error && <p className="error" role="alert">{error}</p>}
      {!data ? (
        !error && <p className="muted">Loading…</p>
      ) : data.sales.length === 0 ? (
        <p className="empty muted">No sales yet.</p>
      ) : (
        <ul className="pa-list">
          {data.sales.map((s) => (
            <li key={s.id}>
              <Link className="pa-row" to={`/platform-admin/sales/${s.id}`}>
                <span className="pa-row-main">
                  <strong>{s.title}</strong>
                  <span className="muted small">
                    /{s.slug} · {s.members.length ? s.members.map((m) => m.displayName).join(', ') : 'No sellers yet'}
                  </span>
                </span>
                <span className="pa-row-meta">
                  <span className="muted small">
                    {s.itemCount} listing{s.itemCount === 1 ? '' : 's'} · {s.inquiryCount} inquir{s.inquiryCount === 1 ? 'y' : 'ies'}
                    {s.newInquiryCount > 0 && <span className="badge">{s.newInquiryCount}</span>}
                  </span>
                  <SaleStatusChip status={s.status} />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
